import { Box } from '@mui/material';
import useIsMobile from '../../isMobile';
import { toAbsoluteUrl } from '../trackingTemplateUtils';

// Single source for the clickable full-width brand banner (desktop=large, mobile=small).
// Returns null when the brand has no banner, so callers render their own logo header instead.
// Replaces the banner block + isMobile/small-large pick that was copy-pasted into all 3 templates
// (the duplication that let the banner be added to two templates and forgotten on the third).
export default function BrandBanner({ brand }) {
    const isMobile = useIsMobile();
    const img = brand && brand.banner ? (isMobile ? brand.banner.small : brand.banner.large) : null;
    if (!img) return null;
    const webUrl = toAbsoluteUrl(brand && brand.webUrl);
    return (
        <Box
            {...(webUrl ? { component: 'a', href: webUrl, target: '_blank', rel: 'noreferrer' } : { component: 'div' })}
            sx={{ display: 'block', cursor: webUrl ? 'pointer' : 'default' }}
        >
            <Box component="img" src={img} alt={(brand && brand.name) || 'Brand banner'} sx={{ width: '100%', display: 'block' }} />
        </Box>
    );
}

// Lets callers decide banner-vs-logo-bar without re-deriving the small/large pick.
export function hasBrandBanner(brand) {
    return !!(brand && brand.banner && (brand.banner.large || brand.banner.small));
}
